module.exports = __webpack_public_path__ + "img/alde-logo.ea7d0455.svg";